import { SettingsContainer } from "../../../SettingsContainer";

import styles from "./ContactInfoSkeleton.module.scss";

type ContactInfoSkeletonProps = {
  rows: number;
  testId: string;
  hasMessage?: boolean;
};

export function ContactInfoSkeleton({
  rows,
  hasMessage = false,
  testId,
}: ContactInfoSkeletonProps) {
  return (
    <SettingsContainer testid={testId}>
      <div className={styles.skeletonContainer}>
        <div className={styles.skeletonButton} />
        <div className={styles.skeletonHeader} />
        {hasMessage && <div className={styles.skeletonMessage} />}
        {Array.from({ length: rows }).map((_, index) => (
          <div key={index}>
            <div className={styles.skeletonRow} />
            <div className={styles.skeletonRow} />
          </div>
        ))}
      </div>
    </SettingsContainer>
  );
}
